import { FunctionComponent, memo, useContext } from "react";
import { IProps } from "./ellipsis-menu-action.types";
import Modal, { ModalContent, ModalHeader, useModal } from "@edgetier/modal";
import { EllipsisMenuContext, EllipsisMenuItem } from "@edgetier/client-components";
import "./ellipsis-menu-action.scss";

/**
 * An action element for ellipsis menu. Display a modal when the item is clicked.
 * @param props.actionLabel     Text displayed for menu item
 * @param props.modalTitle      Text shown in modal header
 * @param props.icon            Icon for menu item
 * @param props.children        Elements rendered inside modal
 */
const EllipsisMenuAction: FunctionComponent<IProps> = ({ actionLabel, modalTitle, icon, children }) => {
    const { lockOpen, unlock } = useContext(EllipsisMenuContext);
    const { openModal, closeModal, modalProps } = useModal({ onCloseModal: unlock });

    return (
        <>
            <Modal {...modalProps}>
                <ModalHeader>
                    <h2>{modalTitle}</h2>
                </ModalHeader>
                <ModalContent>{children(closeModal)}</ModalContent>
            </Modal>
            <EllipsisMenuItem
                closeAfterClick={false}
                icon={icon}
                onClick={() => {
                    lockOpen();
                    openModal();
                }}
            >
                {actionLabel}
            </EllipsisMenuItem>
        </>
    );
};

export default memo(EllipsisMenuAction);
